/**
 * Ghép class có điều kiện. Cố tình KHÔNG kéo `clsx`/`tailwind-merge` vào: nhu cầu ở đây chỉ là
 * bỏ giá trị falsy, và mỗi dependency thêm vào là một thứ phải theo dõi bản vá suốt đời dự án.
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: readonly ClassValue[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
